import { NumberTextField, type NumberTextFieldProps } from 'components/NumberTextField';
import type { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

type IProps = {
  name: string;
  convertTo?: 'number' | 'float';
};

type Props = IProps & NumberTextFieldProps;

export const RHFNumberTextField: FC<Props> = ({ name, convertTo, ...other }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <NumberTextField
          {...field}
          fullWidth
          error={!!error}
          helperText={error?.message}
          onChange={(e) => {
            const rawValue = e.target.value;
            if (rawValue === '') return field.onChange(null);
            let value: number | string = rawValue;
            if (convertTo === 'float') value = +rawValue;
            if (convertTo === 'number') value = parseInt(rawValue, 10);
            field.onChange(value);
          }}
          {...other}
        />
      )}
    />
  );
};
